<template>
    <div class="video-page">
        <p class="current">当前位置：<span>百家大讲堂</span></p>
        <div class="artcle-box">
            <div class="menu">
                <el-menu
                    @select="getMenuIndex"
                    :default-active="activeIndex"
                    class="el-menu-vertical-demo"
                    background-color="#fff"
                    text-color="#000"
                    active-text-color="#00a8a8"
                    :mode="widthNew?'':'horizontal'">
                        <!-- <el-menu-item index="1" @click="handleListarticle(item)"> -->
                        <el-menu-item index="1" >
                            <span slot="title">视频</span>
                        </el-menu-item>
                        <el-menu-item index="2" >
                            <span slot="title">直播</span>
                        </el-menu-item>
                        <el-menu-item index="3" >
                            <span slot="title">课件</span>
                        </el-menu-item>
                        <el-menu-item index="4" ><!--  -->
                            <span slot="title">企业管理体系</span>
                        </el-menu-item>
                
                </el-menu>
            </div>
            <videoList v-show="!status" :videoData="videoData" :type="2" :activeIndex="activeIndex" @keywordsInput="keywordsInput"></videoList>
            <div v-show="status" class="article-right">
                <Search class="searchWidth" @inputKey="inputKey"></Search>
                <div style="width: 100%;display: flex;justify-content: flex-start; flex-flow: row wrap;" v-if="activeIndex == 4">
                    <div v-for="item in ManagementSystList" :key="item.id" @click="getInfo(item)" style="margin: 10px 6px 10px 5px;">
                        <div class="videoContent-div">
                            <div :style="'background-image:url('+item.firstFile.FileUrl+');background-size: cover;background-repeat: no-repeat;background-position: center;'"></div>
                            <p class="videoTitle">{{ item.name }}</p>
                        </div>

                    </div>
                </div>
                
                <el-pagination
                    :hide-on-single-page="hideOnSinglePage"
                    :page-size="9"
                    :pager-count="11"
                    @current-change="handleCurrentChange"
                    layout="prev, pager, next"
                    :total="total">
            </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import videoList from '../video/videoList.vue';
import ListLive from './listlive.vue'
import Search from '../search/index.vue'

export default {
    data(){
        return{
            parent_cate_value: ['maintype'],
            cate: '',
            keywords: '',
            videoList: [],
            total: 0,
            hideOnSinglePage: true,
            activeIndex: "1",
            videoData: [],
            widthNew: false,
            status: false,
            hideOnSinglePage: true,
            ManagementSystList: []
        }
    },
    components:{
        videoList,
        ListLive,
        Search
    },
    methods:{
        getManagementList(data){
            this.ManagementSystList = []
            this.total = 0
            this.$store.dispatch('video/listManagementSystem',data)
                .then(res => {
                    this.ManagementSystList = res.data.items
                    this.total = res.data.total
                    if(this.total <= 9){
                        this.hideOnSinglePage = true
                    }else{
                        this.hideOnSinglePage = false
                    }
                })
        },
        keywordsInput(val){
            this.keywords = val
        },
        getMenuIndex(key,keyPath){
            console.log(key);
            this.activeIndex = key
            this.status = false
            if(key == 1){
                console.log(value);
                let data = {
                    pageNum: 1,
                    pageSize: 9,
                    cate: this.cate,
                    keywords: this.keywords,
                }
                this.videoData = data
            }else if(key == 4){
                this.status = true

               
            }
        },
        inputKey(val){
            // this.keywords = val
            // this.$emit('keywordsInput',val)
            // let data = {
            //     pageNum: 1,
            //     pageSize: 9,
            //     cate: this.cate,
            //     keywords: val,
            // }
            // if(this.activeIndex == 1){
                
            //     this.getVideoList(data)
            // }else if(this.activeIndex == 2){
            //     this.handlListlive(data)
            // }else if(this.activeIndex == 3){
            //     this.handleCourseware(data)
            // }
        },
        handleCurrentChange(val){
            console.log(`当前页: ${val}`);
            // this.currentChange = val
            // console.log(value);
            // let data = {
            //     pageNum: val,
            //     pageSize: 9,
            //     cate: this.cate,
            //     keywords: this.keywords,
            // }
            // this.getVideoList(data)
        },
        getInfo(item){
            console.log(item);
            this.$router.push({
                path: '/managementInfo',
                query: {
                    key: item.id
                }
            })
        }
    },
    mounted(){
      
    },
    created(){
        let widthNew = document.documentElement.clientWidth
        if(widthNew > 540){
            this.widthNew = true
        }else{
            this.widthNew = false
        }

        let data = {
            pageNum: 1,
            pageSize: 9,
            keywords: ''
        }

        this.getManagementList(data)
    }

}
</script>
<style scoped lang="scss">

.current{
    margin-top: -45px;
    position: relative;
    font-size: 17px;
    color: #333;
}
.current span{
    font-size: 16px;
    cursor: pointer;
    color: #666666;
}


.menu{
    width: 200px;
    background: #fff;
    padding: 15px 15px;
    align-self: flex-start;
    text-align: center;
}
.menu .el-menu{border:0;}

.el-menu-item {
  background-color: rgba(0, 0, 0, 0.1);
  font-size: 18px;
  margin-top:1px;
}
.el-menu-item.is-active {
  background-color: #fff !important;
  border-bottom: 1px solid rgba(0, 168, 168, 0.1) !important;
  margin-top:1px;
}
.el-menu-item:hover{
    background-color: #fff !important;
    color: rgb(0, 168, 168);
    margin-top:1px;
}
@media screen and (min-width: 541px) {
    .video-page{
        width: 1200px;
        margin: 55px auto;
    }
    .artcle-box{
        width: 1200px;
        min-height: calc(100vh - 190px);
        margin: 15px auto;
        display: flex;
        justify-content: flex-start;
        
    }
}
.article-right{
    width: 920px;
    // margin-left: 10px;
    background: #fff;
    padding: 15px 15px;

}

.videoContent-div{
    width: 295px;height: 260px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    cursor: pointer;
} 
.videoContent-div div{
    width: 294px; height: 200px;
}

.videoTitle{
    font-size: 18px;
    height: 50px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    padding: 5px 10px 5px 10px;
    margin-top: 20px;
}
</style>